export default __webpack_public_path__ + "static/media/onboardingVideoImg.0767f450.png";